/**
 * @fileoverview Helpers de formulário de cartão + tokenização client-side
 * (Pagar.me.js). O número/CVV são enviados DIRETO do browser para a Pagar.me
 * (`/tokens?appId=chave_publica`) — nunca passam pelo nosso servidor. Usado pelo
 * checkout e pela troca de cartão (aba Faturamento).
 */

const PAGARME_PUBLIC_KEY = process.env.REACT_APP_PAGARME_PUBLIC_KEY || "";

export const hasPagarmePublicKey = () => !!PAGARME_PUBLIC_KEY;

export const onlyDigits = s => (s || "").replace(/\D/g, "");

export function applyMask(digits, mask) {
  let out = "", di = 0;
  for (const ch of mask) {
    if (di >= digits.length) break;
    if (ch === "#") out += digits[di++];
    else out += ch;
  }
  return out;
}

export function detectBrand(number) {
  const n = onlyDigits(number);
  if (!n) return null;
  if (/^4/.test(n)) return "visa";
  if (/^3[47]/.test(n)) return "amex";
  if (/^(606282|3841)/.test(n)) return "hipercard";
  if (/^(4011|4312|4389|4514|4576|5041|5066|5067|509|627780|636297|636368|650|6516|6550)/.test(n)) return "elo";
  if (/^3(0[0-5]|6|8)/.test(n)) return "diners";
  if (/^(5[1-5]|2(2[2-9]|[3-6][0-9]|7[01]|720))/.test(n)) return "mastercard";
  return null;
}

export function maskedNumber(number) {
  const n = onlyDigits(number).slice(0, 19);
  const padded = n.padEnd(Math.max(16, n.length), "•");
  return (padded.match(/.{1,4}/g) || []).join(" ");
}

export const formatExpiry = v => {
  const d = onlyDigits(v).slice(0, 6);
  return d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d;
};

/**
 * Tokeniza o cartão na Pagar.me (uso único, expira em 60s). Retorna o token id.
 * Lança Error com a mensagem da Pagar.me em caso de falha.
 */
export async function tokenizeCard(card) {
  const d = onlyDigits(card.expiry);
  const exp_month = Number(d.slice(0, 2));
  const yr = d.slice(2);
  const exp_year = Number(yr.length >= 2 ? yr.slice(-2) : yr);
  const url = `https://api.pagar.me/core/v5/tokens?appId=${encodeURIComponent(PAGARME_PUBLIC_KEY)}`;
  const r = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      type: "card",
      card: { number: onlyDigits(card.number), holder_name: card.holder, exp_month, exp_year, cvv: card.cvv }
    })
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok || !data.id) {
    const msg = data?.errors ? Object.values(data.errors).flat().join("; ") : data?.message;
    throw new Error(msg || "tokenize_failed");
  }
  return data.id;
}
